'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FadeWrapper;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FadeWrapper(_ref) {
  var focused = _ref.focused,
      fadeOpacity = _ref.fadeOpacity,
      children = _ref.children;

  var wrapper = _style2.default.wrapper;
  var opacity = 1;

  if (!focused) {
    wrapper += ' ' + _style2.default.hidden;
    opacity = !fadeOpacity ? 0 : fadeOpacity;
  }

  return _react2.default.createElement(
    'div',
    { className: wrapper, style: { opacity: opacity } },
    children
  );
} /**
   * Copyright 2013-2015, Hudl
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * @providesModule FadeWrapper
   */

FadeWrapper.propTypes = {
  children: _propTypes2.default.node.isRequired,
  fadeOpacity: _propTypes2.default.number,
  focused: _propTypes2.default.bool
};
module.exports = exports['default'];